const BAPLIE_FILE_TYPES = {
  DISCHARGE: 'discharge',
  LOAD: 'load',
  RESTOW: 'restow',
}

export default BAPLIE_FILE_TYPES
